import {
  GET_CHANCE_GAMES_COUPONS_REQUEST,
  GET_CHANCE_GAMES_COUPONS_SUCCESS,
  GET_CHANCE_GAMES_COUPONS_FAILURE
} from 'Store/constants';

const initialState = {
  coupons: [],
  pagination: {
    pageSize: 10,
    pageIndex: 0,
    hasMore: true
  },
  isFetched: false,
  isLoading: false,
  error: null,
};

const getHasMoreStatus = (length = 0) => {
  return !!(length && length === 10);
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CHANCE_GAMES_COUPONS_REQUEST:
      return { ...state, isLoading: !!action.payload.resetPagination, isFetched: false, error: null };
    case GET_CHANCE_GAMES_COUPONS_SUCCESS:
      return {
        ...state,
        coupons: action.payload.resetPagination ? action.payload.coupons : [
          ...state.coupons,
          ...action.payload.coupons
        ],
        pagination: {
          ...state.pagination,
          pageIndex: action.payload.resetPagination ? 1 : state.pagination.pageIndex + 1,
          hasMore: getHasMoreStatus(action.payload.coupons.length)
        },
        isFetched: true,
        isLoading: false,
        error: null
      };
    case GET_CHANCE_GAMES_COUPONS_FAILURE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          hasMore: false
        },
        isFetched: true,
        isLoading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};
